<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-12 pt-3 pb-3 pl-4">
          <h3><i class="fas fa-id-badge"></i> Cadastro de Usuario Tv</h3>
        </div>
      </div>
      <TvAdd v-if="showAdd" ref="TvAdd" v-on:Back="onBack" />
      <TvList v-else ref="TvList" v-on:New="onNew" v-on:Edit="onEdit"/>
    </div>
  </template>
<script>
import Tools from '@/components/tools/Tools.js'
import TvAdd from './components/add/tvAdd.vue'
import TvList from './components/list/tvList.vue'

export default {
  name: 'Tv',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    TvAdd,
    TvList
  },
  mounted () { },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onLoad () {},
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.TvAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/tv/tv.vue